(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lsl-offer-urgency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lsl-offer-urgency')) {
    customElements.define('lsl-offer-urgency', class extends HTMLElement {
      connectedCallback() {
        const update = () => {
          clearTimeout(this.expiryTimer);
          const remaining = Date.parse(this.dataset.end) - Date.now();
          this.hidden = !Number.isFinite(remaining) || remaining <= 0;
          if (!this.hidden) this.expiryTimer = setTimeout(update, Math.min(remaining, 2147483647));
        };
        update();
      }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lsl-purchase-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lsl-purchase-enhancement')) {
  customElements.define('lsl-purchase-enhancement', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.product-info');
      if (!this.root) return;
      this.onClick = (event) => {
        const button = event.target.closest('.lsl-gift-config');
        if (!button || !this.root.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const gift = button.closest('.kaching-bundles__upsell');
        const open = gift.classList.toggle('lsl-gift-open');
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? this.dataset.close : this.dataset.customize;
      };
      this.root.addEventListener('click', this.onClick, true);
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.enhance(); });
      });
      this.observer.observe(this.root, {childList:true, subtree:true});
      this.enhance();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('click', this.onClick, true);
    }
    enhance() {
      this.root.querySelectorAll('.lsl-purchase-panel').forEach(panel => {
        panel.classList.toggle('lsl-combat-bundle', this.dataset.combatBundle === 'true');
        const picker = panel.querySelector('variant-picker');
        const bundle = panel.querySelector('kaching-bundles-block');
        if (!picker || !bundle) return;
        const chosen = Array.from(picker.querySelectorAll('input[type="radio"]:checked')).map(input => {
          const label = picker.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          return label?.textContent.trim();
        });
        const mainSelects = Array.from(bundle.querySelectorAll('.kaching-bundles__bar-collection-products select'));
        const synced = this.dataset.combatBundle !== 'true' && mainSelects.length > 0 && mainSelects.every(select => chosen.includes(select.value));
        panel.classList.toggle('lsl-purchase-synced', synced);
        bundle.querySelectorAll('.kaching-bundles__bar-most-popular__content').forEach(badge => {
          if (!/halloween|🎃|(?:deux|2)\s+sabres\s+offert|2\s+free\s+sabers/i.test(badge.textContent)) return;
          badge.classList.add('lsl-halloween-badge');
          if (this.dataset.halloweenBadge && badge.textContent !== this.dataset.halloweenBadge) {
            badge.textContent = this.dataset.halloweenBadge;
          }
          const wrapper = badge.parentElement;
          wrapper.classList.add('lsl-halloween-heading');
          if (!wrapper.querySelector('.lsl-halloween-deadline') && this.dataset.deadline) {
            const deadline = document.createElement('span');
            deadline.className = 'lsl-halloween-deadline';
            deadline.textContent = this.dataset.deadline;
            wrapper.appendChild(deadline);
          }
        });
        bundle.querySelectorAll('.kaching-bundles__upsell').forEach(gift => {
          const content = gift.querySelector('.kaching-bundles__upsell__content');
          const variant = content?.querySelector('.kaching-bundles__bar-variant');
          if (!content || !variant) return;
          let button = content.querySelector('.lsl-gift-config');
          if (!button) {
            button = document.createElement('button');
            button.type = 'button'; button.className = 'lsl-gift-config';
            button.textContent = this.dataset.customize;
            button.setAttribute('aria-expanded','false');
            content.insertBefore(button, variant);
            const summary = document.createElement('span');
            summary.className = 'lsl-gift-summary';
            content.insertBefore(summary, button);
          }
          const summary = content.querySelector('.lsl-gift-summary');
          const text = Array.from(variant.querySelectorAll('select')).filter(s=>s.options.length>1).map(s=>s.value).join(' · ');
          if (summary.textContent !== text) summary.textContent = text;
          gift.classList.add('lsl-gift-enhanced');
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lsl-quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lsl-quantity-controls')) {
  customElements.define('lsl-quantity-controls', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="quantity"]');
      this.buttons = this.querySelectorAll('.quantity-selector__button');
      if (!this.input || this.buttons.length !== 2) return;
      this.controller = new AbortController();
      const update = () => queueMicrotask(() => {
        if (!this.isConnected) return;
        const value = this.input.valueAsNumber;
        const min = this.input.min === '' ? 1 : Number(this.input.min);
        const max = this.input.max === '' ? Infinity : Number(this.input.max);
        this.buttons[0].disabled = this.input.disabled || value <= min;
        this.buttons[1].disabled = this.input.disabled || value >= max;
      });
      this.addEventListener('input', update, { signal: this.controller.signal });
      this.addEventListener('change', update, { signal: this.controller.signal });
      this.observer = new MutationObserver(update);
      this.observer.observe(this.input, { attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'value'] });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lsl-video-shortcuts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lsl-video-shortcuts')) {
  customElements.define('lsl-video-shortcuts', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('.lsl-videos__preview img').forEach(image => {
        image.addEventListener('error', () => { image.hidden = true; }, options);
        if (image.complete && !image.naturalWidth) image.hidden = true;
      });
      this.querySelectorAll('[data-video-id]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', this.dialog.id);
      });
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-video-id]');
        if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const id = link.dataset.videoId;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        this.openVideo(link, id);
      }, options);
      this.querySelector('[data-video-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.cleanup(), options);
    }
    openVideo(link, id) {
      if (this.dialog.open) return;
      this.trigger = link;
      this.querySelector('[data-video-heading]').textContent = link.dataset.videoTitle;
      this.querySelector('[data-video-caption]').textContent = link.dataset.videoNote;
      this.querySelector('[data-video-external]').href = link.href;
      const iframe = document.createElement('iframe');
      iframe.title = link.dataset.videoTitle;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      this.querySelector('[data-video-player]').replaceChildren(iframe);
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.dispatchEvent(new CustomEvent('lsl:video-open', { bubbles: true, detail: { videoId: id, title: link.dataset.videoTitle } }));
    }
    cleanup() {
      this.querySelector('[data-video-player]')?.replaceChildren();
      if (this.previousOverflow !== undefined) document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      this.trigger = null;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.cleanup();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
